<template>
  <div>
    <div class="five_step_box mb-20" v-if="true">
      <fiveStep :step="2"></fiveStep>
    </div>
    <div class="exercise_consolidation p-20">
      <div class="flex FlexBetween Flexalign">
        <div class="flex Flexalign through_base">
          <div class="exercise-title">· 章节闯关</div>
          <el-image class="green_doubt_icon ml-10" :src="iconPath('green_doubt_icon.png')" @mouseenter="showUseRule"
            @mouseleave="hideUseRule"></el-image>
          <div class="use_rule_box" v-if="showUseRuleFlag">
            <div class="use_rule_title">模式介绍</div>
            <div>
              <div>普通模式：达到指定的正确率即可闯关成功。</div>
              <div>通关模式：所有题目必须全部回答正确即可</div>
              <div>错题模式：每错一道题目会增加对应的题目数</div>
            </div>
          </div>
        </div>
        <div class="flex Flexalign">
          <div class="btn_previous btn_next cursor_pointer" @click="previoustep">
            上一步
          </div>
          <div class="btn_next ml-20 cursor_pointer" @click="nextStep">
            下一步
          </div>
        </div>
      </div>
      <div class="homework_name">{{ homeworkInfo.examName }}</div>
      <div class="homework_info flex Flexalign Flexjustify mt-15">
        <div class="flex Flexalign mr-24">
          <el-image class="test_question_num" :src="iconPath('test_question_num.png')"></el-image>
          <div class="ml-5">每关题数：{{ homeworkInfo.otherRule?.maxLevelQuestions }}题</div>
        </div>
        <div class="flex Flexalign mr-24">
          <el-image class="test_question_num" :src="iconPath('through_type.png')"></el-image>
          <div class="ml-5">闯关模式：{{ homeworkInfo.mode == 1 ? '普通模式' : (homeworkInfo.mode == 2 ? '通关模式' : '错题模式') }}
          </div>
        </div>
        <div class="flex Flexalign">
          <el-image class="test_question_num" :src="iconPath('test_time_icon.png')"></el-image>
          <div class="ml-5">作答时间：{{
            getAnswerTimeText(homeworkInfo.otherRule?.timeType, homeworkInfo.otherRule?.perQuestionTime,
              homeworkInfo.otherRule?.totalTime)
          }}</div>
        </div>
      </div>
      <!-- 无该字段了 -->
      <!-- <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">关卡描述</div>
    </div>
    <div class="level_desc mt-15">{{ homeworkInfo.examDetail }}</div> -->
      <div class="homework_difficult flex Flexalign mt-20">
        <div class="line_green"></div>
        <div class="difficult_text ml-8">当前进度</div>
      </div>
      <div class="level_list flex FlexWrap">
        <div class="level_one flex Flexalign mt-40" v-for="(item, index) in homeworkInfo.examPaperList" :key="index">
          <div class="level_one_box">
            <el-image class="level_pass" :src="iconPath('level_pass.png')" v-if="item.isCorrect == 1"></el-image>
            <el-image class="level_pass" :src="iconPath('level_now.png')" v-if="item.isCorrect == 2"></el-image>
            <el-image class="level_pass" :src="iconPath('level_lock.png')"
              v-if="item.isCorrect == 0 || item.isCorrect == 3"></el-image>
            <div class="level_num" :class="item.isCorrect == 2
              ? 'level_num_yellow'
              : (item.isCorrect == 0 || item.isCorrect == 3)
                ? 'level_num_gray'
                : ''
              ">
              {{ item.sort }}
            </div>
            <div class="level_user flex flexcolumn Flexalign Flexjustify" v-if="item.isCorrect == 2">
              <el-image class="avatar_container" :src="iconPath('avatar_container.png')"></el-image>
            </div>
            <div class="level_user flex flexcolumn Flexalign Flexjustify" v-if="item.isCorrect == 2">
              <el-image class="headImage" :src="userInfo.headImage"></el-image>
            </div>
            <div class="level_lock" v-if="item.isCorrect == 0 || item.isCorrect == 3">
              <el-image class="lock_icon" :src="iconPath('lock_icon.png')"></el-image>
            </div>
            <div class="level_again">
              <el-image class="through_again cursor_pointer" :src="iconPath('through_again.png')"
                v-if="item.isCorrect == 1" @click="goChallenge(item.paperId, item.sort)"></el-image>
              <el-image class="through_again cursor_pointer" :src="iconPath('through_go.png')"
                v-if="item.isCorrect == 2" @click="goChallenge(item.paperId, item.sort)"></el-image>
            </div>
          </div>
          <div class="level_one_line" v-if="index != homeworkInfo.examPaperList.length - 1"></div>
        </div>
      </div>
      <challengePopup></challengePopup>
    </div>
  </div>
</template>

<script>
import challengePopup from "@/components/popup/challengePopup.vue";
import fiveStep from "./fiveStep.vue";
import { debounce } from "@/assets/utils/dbucTrtl";
import { mapState } from "vuex";
export default {
  name: "GjkcH5ChapterChallenge",
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  inject: ["practiceBack", "updateShowPractice"],
  components: { challengePopup, fiveStep },

  data() {
    return {
      showUseRuleFlag: false,
      planValue: 1,
      planOptions: [
        { label: "普通闯关", value: 1 },
        { label: "地狱闯关", value: 2 },
        { label: "魔鬼闯关", value: 3 },
      ],
      homeworkInfo: {
        // name: "关卡名称关卡名称关卡名称",
        // questionNum: 20,
        // levelType: "普通闯关",
        // effectiveTime: 60,
        // desc: "考察范围：集合与常用逻辑，函数与导数，计考察范围：集合与常用逻辑，函数与导数，计考察范围：集合与常用逻辑，函数与导数，计考察范围：集合与常用逻辑，函数与导数，计",
        // levelList: [
        //   { num: "01", state: 1 }, // state：1 已经闯关，2 当前关卡， 3 未解锁
        //   { num: "02", state: 1 },
        //   { num: "03", state: 2 },
        //   { num: "04", state: 3 },
        //   { num: "05", state: 3 },
        //   { num: "06", state: 3 },
        //   { num: "07", state: 3 },
        // ],
      },
    };
  },

  mounted() {
    this.getChallengeInfo();
  },

  methods: {
    // 上一步（没有上一章节阶段）
    previoustep() {
      this.$store.commit("learning/setStudyPreviousStep", 3);
    },
    nextStep() {
      this.$store.commit("learning/setStudyStepInfo", 3);
    },
    getAnswerTimeText(type, oneTime, totalTime) {
      if (type == 1) {
        return '不限'
      } else if (type == 2) {
        return `每题${this.$Tools.secondToMinuteFormatNew(oneTime)}`
      } else if (type == 3) {
        return `${this.$Tools.secondToMinuteFormatNew(totalTime)}`
      }
    },
    showUseRule() {
      this.showUseRuleFlag = true;
    },
    hideUseRule() {
      this.showUseRuleFlag = false;
    },
    goChallenge(paperId, sort) {
      this.$store.commit('exam/setChallengeSort', sort);
      // this.updateShowPractice(true, paperId);
      this.goChallengeTest(paperId, sort);
      this.$store.commit("exam/setIsChallengeSubmit", true);
    },
    goChallengeTest: debounce(
      function (paperId, sort) {
        this.updateShowPractice(true, paperId, sort);
      },
      1000,
      false
    ),
    getChallengeInfo() {
      this.$Api.course
        .getChallengeInfo(
          this.selectLearningInfo.courseId,
          this.selectLearningInfo.schemeId,
          this.selectLearningInfo.roundId,
          this.selectLearningInfo.id,
          this.selectLearningInfo.chapterId
        )
        .then((res) => {
          this.homeworkInfo = res.data.data;
          if (!this.$Tools.empty(this.homeworkInfo)) {
            // 查找isCorrect = 2即正在闯关的未提交的，若没有找到，默认第一个未解锁的/闯关失败的isCorrect 3为当前关卡
            let currentChallenge = this.homeworkInfo.examPaperList.findIndex(item => item.isCorrect == 2);
            if (currentChallenge == -1) {
              currentChallenge = this.homeworkInfo.examPaperList.findIndex(item => (item.isCorrect == 0 || item.isCorrect == 3))
            }
            this.homeworkInfo.examPaperList[currentChallenge].isCorrect = 2;
          }
        }).catch(() => {

        });
    },
  },
};
</script>

<style lang="scss" scoped>
.exercise_consolidation {
  width: 762px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #111111;

  .exercise-title {
    font-size: 18px;
    font-weight: 600;
  }

  .through_base {
    position: relative;

    .green_doubt_icon {
      width: 18px;
      height: 18px;
    }

    .use_rule_box {
      z-index: 9;
      position: absolute;
      top: -90px;
      // left: -180px;
      left: 140px;
      width: 231px;
      // height: 166px;
      padding: 15px 10px;
      background: #ffffff;
      box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      font-size: 14px;
      color: #666666;
      line-height: 21px;
      max-height: 150px;
      overflow: auto;

      .use_rule_title {
        color: #111111;
        line-height: 21px;
      }
    }
  }

  .btn_next {
    width: 69px;
    height: 30px;
    line-height: 30px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 18px;
    text-align: center;
    color: #fff;
  }

  .btn_previous {
    background: none;
    border: 1px solid #909090;
    color: #909090;
  }

  .level_type_mode {
    :deep(.el-select__wrapper) {
      box-shadow: none;
    }

    :deep(.el-select__wrapper.is-focused) {
      box-shadow: none;
    }
  }

  .homework_name {
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #111111;
  }

  .homework_info {
    .test_question_num {
      width: 22px;
      height: 22px;
    }
  }

  .homework_difficult {
    font-size: 12px;
    color: #999999;

    .line_green {
      width: 3px;
      height: 16px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 4px;
    }

    .difficult_text {
      font-size: 14px;
      color: #111111;
    }

    .difficult_one {
      width: 60px;
      height: 25px;
      background: #f5f5f5;
      border-radius: 15px;
      line-height: 25px;
      text-align: center;
    }

    .difficult_one_actove {
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      color: #fff;
    }
  }

  .level_desc {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
  }

  .level_list {
    .level_one {
      .level_one_box {
        position: relative;
        width: 118px;
        height: 82px;
        text-align: center;
        line-height: 82px;

        .level_pass {
          position: absolute;
          left: 0;
          top: 0;
          width: 118px;
          height: 82px;
        }

        .level_num {
          position: absolute;
          width: 50px;
          height: 50px;
          top: -10px;
          left: 34px;
          font-size: 22px;
          color: #fff;
          text-shadow: 0 0 5px #b1efff, 0 0 10px #2dc2ef;
        }

        .level_num_yellow {
          color: #fff;
          text-shadow: 0 0 5px #fff2b1, 0 0 10px #eeb70c;
        }

        .level_num_gray {
          color: #fff;
          text-shadow: 0 0 5px #f7fdff, 0 0 10px #c0c0c0;
        }

        .level_user {
          position: absolute;
          top: -40px;
          left: 34px;
          width: 55px;
          height: 55px;

          .avatar_container {
            width: 55px;
            height: 55px;
          }

          .headImage {
            width: 33px;
            height: 33px;
            border-radius: 50%;
          }
        }

        .level_lock {
          position: absolute;
          right: 0;
          bottom: -30px;

          .lock_icon {
            width: 51px;
            height: 51px;
          }
        }

        .level_again {
          position: absolute;
          bottom: -23px;
          left: 30px;

          .through_again {
            width: 57px;
            height: 26px;
          }
        }
      }

      .level_one_line {
        width: 22px;
        // height: 1px;
        border: 1px dashed #2f9fee;
      }
    }
  }
}
</style>